import { inject, Pipe, PipeTransform } from '@angular/core'
import { TextTransformerService } from '@shared/services/text-transformer.service'

@Pipe({
	name: 'percent',
})
export class PercentPipe implements PipeTransform {
	private readonly _textTransformerService: TextTransformerService =
		inject<TextTransformerService>(TextTransformerService)

	transform(value: number | string | null | undefined, isReduceMin: boolean = false): string {
		return this._textTransformerService.toPercent(value, isReduceMin)
	}
}
